import React, { useState, useEffect, useCallback } from 'react';
import './style.scss';
import Icon from 'react-icons-kit';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { chevronLeft } from 'react-icons-kit/feather';
import Requests from '../../../../utils/Requests/Index';
import LoadingComponent from '../../../../components/loading/Index';

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [item, setItem] = useState(null);

 const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

  /* ----------------------------------
     Fetch profile data
  -----------------------------------*/
  const fetchData = useCallback(async () => {
    try {
      const data = await Requests.AppointmentBooking.Show(id, header);
      if (data) {
        setItem(data);
        // setItems(Array.isArray(data.features) ? data.features : []);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [id, header]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  /* ----------------------------------
     Submit update
  -----------------------------------*/
  const onSubmit = async (data) => {
    try {
      setUpdating(true);

      const payload = {
        ...data,
      };

      await Requests.AppointmentBooking.Update(id, payload, header);
      toast.success('Profile updated successfully');
      navigate('/dashboard/website/appointment-booking');
    } catch (err) {
      console.error(err);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <LoadingComponent />;

  return (
    <div className="store-blog pb-4">
      <div className="container-fluid">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white p-4 d-flex justify-content-between">
            <h6>Edit Appointment Booking</h6>
            <Link
              to="/dashboard/website/appointment-booking"
              className="btn shadow-none rounded-circle"
            >
              <Icon icon={chevronLeft} size={22} />
            </Link>
          </div>

          <div className="card-body p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Name */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.name && errors.name.message ? (
                            <p className="text-danger">{errors.name && errors.name.message}</p>
                        ) : <p>Name</p>
                        }

                        <input
                            type="text"
                            name="name"
                            defaultValue={item.name}
                            className="form-control shadow-none"
                            placeholder="Enter Name"
                            {...register("name",{ required: "Name is required" })}
                        />
                    </div>
                </div>

                {/* phone */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.phone && errors.phone.message ? (
                            <p className="text-danger">{errors.phone && errors.phone.message}</p>
                        ) : <p>Phone</p>
                        }

                        <input
                            type="text"
                            name="phone"
                            defaultValue={item.phone}
                            className="form-control shadow-none"
                            placeholder="Enter Phone"
                            {...register("phone",{ required: "Phone is required" })}
                        />
                    </div>
                </div>
              </div>

            {/*  */}
            <div className="row">
                {/* package */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.package && errors.package.message ? (
                            <p className="text-danger">{errors.package && errors.package.message}</p>
                        ) : <p>Package</p>
                        }

                        <input
                            type="text"
                            name="package"
                            className="form-control shadow-none"
                            defaultValue={item?.package}
                            placeholder="Enter Package"
                            {...register("package",{ required: "Package is required" })}
                        />
                    </div>
                </div>

                {/* mediumOfAdvice */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.mediumOfAdvice && errors.mediumOfAdvice.message ? (
                            <p className="text-danger">{errors.mediumOfAdvice && errors.mediumOfAdvice.message}</p>
                        ) : <p>Medium of Advice</p>
                        }

                        <input
                            type="text"
                            name="mediumOfAdvice"
                            className="form-control shadow-none"
                            placeholder="Enter Medium of Advice"
                            defaultValue={item?.mediumOfAdvice}
                            {...register("mediumOfAdvice",{ required: "Medium of Advice is required" })}
                        />
                    </div>
                </div>

                {/* accept */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.accept && errors.accept.message ? (
                            <p className="text-danger">{errors.accept && errors.accept.message}</p>
                        ) : <p>Accept</p>
                        }

                        <input
                            type="text"
                            name="accept"
                            className="form-control shadow-none"
                            placeholder="Enter Accept"
                            defaultValue={item?.accept}
                            {...register("accept",{ required: "Accept is required" })}
                        />
                    </div>
                </div>

                {/* date */}
                <div className="col-12 col-md-6">
                    <div className="form-group mb-4">
                        {errors.date && errors.date.message ? (
                            <p className="text-danger">{errors.date && errors.date.message}</p>
                        ) : <p>Date</p>
                        }

                        <input
                            type="date"
                            name="date"
                            className="form-control shadow-none"
                            defaultValue={
                                item?.date
                                ? new Date(item.date).toISOString().split('T')[0]
                                : ''
                            }
                            {...register('date', { required: 'Date is required' })}
                        />

                    </div>
                </div>
            </div>


              <div className="text-end mt-4">
                <button className="btn btn-primary" disabled={updating}>
                  {updating ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;


